import React from "react";
import EasasGlobalAlerts from "./EasasGlobalAlerts";
import EasasGlobalChartDialog from "./EasasGlobalChartDialog";

export default function EasasGlobalFragment() {
    return <>
        <EasasGlobalAlerts/>
        <EasasGlobalChartDialog/>
    </>
}